__turbopack_context__.v({
  "accordion": "Measures-module__eM2zfa__accordion",
  "body": "Measures-module__eM2zfa__body",
  "bodyDesktop": "Measures-module__eM2zfa__bodyDesktop",
  "bodyMobile": "Measures-module__eM2zfa__bodyMobile",
  "carousel": "Measures-module__eM2zfa__carousel",
  "categoryBody": "Measures-module__eM2zfa__categoryBody",
  "categoryBodyDesktop": "Measures-module__eM2zfa__categoryBodyDesktop",
  "categoryBodyMobile": "Measures-module__eM2zfa__categoryBodyMobile",
  "categoryLink": "Measures-module__eM2zfa__categoryLink",
  "categoryNote": "Measures-module__eM2zfa__categoryNote",
  "categoryTitle": "Measures-module__eM2zfa__categoryTitle",
  "copy": "Measures-module__eM2zfa__copy",
  "copyHead": "Measures-module__eM2zfa__copyHead",
  "cta": "Measures-module__eM2zfa__cta",
  "intro": "Measures-module__eM2zfa__intro",
  "introCopy": "Measures-module__eM2zfa__introCopy",
  "list": "Measures-module__eM2zfa__list",
  "media": "Measures-module__eM2zfa__media",
  "row": "Measures-module__eM2zfa__row",
  "rowImageLeft": "Measures-module__eM2zfa__rowImageLeft",
  "section": "Measures-module__eM2zfa__section",
  "title": "Measures-module__eM2zfa__title",
  "titleDesktop": "Measures-module__eM2zfa__titleDesktop",
  "titleMobile": "Measures-module__eM2zfa__titleMobile",
});
